import Button from "components/base/Button";
import { useMemo, useState } from "react";

const ImageUrlsSelector = ({
  availableUrls = [],
  initialSelectedUrls = [],
  onDone,
}) => {
  const [selectedUrls, setSelectedUrls] = useState(initialSelectedUrls);
  const selectedSet = useMemo(() => new Set(selectedUrls), [selectedUrls]);

  function toggleUrl(url) {
    if (selectedSet.has(url)) {
      setSelectedUrls((prev) => prev.filter((item) => item !== url));
      return;
    }
    setSelectedUrls((prev) => [...prev, url]);
  }

  return (
    <div className="flex flex-col flex-1 max-h-[70vh]">
      <div className="flex-1 overflow-auto space-y-2">
        {availableUrls.length === 0 ? (
          <div className="text-sm opacity-70">No product images available.</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {availableUrls.map((url) => (
              <div
                key={url}
                className="relative border dark:border-gray-700 rounded cursor-pointer overflow-hidden"
                onClick={() => toggleUrl(url)}
              >
                <img
                  src={url}
                  alt="Product"
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute top-2 right-2 bg-white/90 dark:bg-gray-900/90 rounded p-1">
                  <input
                    type="checkbox"
                    checked={selectedSet.has(url)}
                    onChange={() => toggleUrl(url)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="pt-4 mt-3 border-t dark:border-gray-700 flex items-center justify-between">
        <div className="text-xs opacity-70">
          {selectedUrls.length} image{selectedUrls.length === 1 ? "" : "s"} selected
        </div>
        <Button primary onClick={() => onDone(selectedUrls)}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default ImageUrlsSelector;
